import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=03523a75&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=ts&"
export * from "./Box.vue?vue&type=script&lang=ts&"
import style0 from "./Box.vue?vue&type=style&index=0&id=03523a75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03523a75",
  null
  
)

export default component.exports